export class FirmwareView {
    name: string;
    constructor(name: string) {
        this.name = name;
    }
}

export class DeviceTypeView {
    name: string;
    constructor(name: string) {
        this.name = name;
    }
}

export class Device {
    id: number;
    name: string;
    device_type: string;
    fwVersion: string;
    fwVersionTime: string;
    targetVersion: string;
    lastComm: string;
    tags: string[];
    force_version: boolean;
    display_name: string;
    data: any
    constructor(id: number, name: string, deviceType: string, fwVersion: string, targetVersion: string, tags: string[], force_version: boolean, data: {}, fwVersionTime: string, lastComm: string, displayName: string) {
        this.id = id;
        this.name = name;
        this.display_name = displayName;
        this.device_type = deviceType;
        this.fwVersion = fwVersion;
        this.targetVersion = targetVersion;
        this.tags = tags;
        this.data = data;
        this.force_version = force_version;
        this.fwVersionTime = fwVersionTime;
        this.lastComm = lastComm;
    }
}

export class DeviceCSVInfo {
    name: string;
    type: string;
    fw_version: string;
    fw_version_time: string;
    target_version: string;
    last_comm: string;
    tags: string[];
    force_version: boolean;
    display_name: string;
    address: string;
    data: string;
    constructor(name: string, type: string, fw_version: string, target_version: string, tags: string[], force_version: boolean, data: string, fw_version_time: string, last_comm: string, display_name: string, address: string) {
        this.name = name;
        this.display_name = display_name;
        this.type = type;
        this.fw_version = fw_version;
        this.target_version = target_version;
        this.tags = tags;
        this.data = data;
        this.force_version = force_version;
        this.fw_version_time = fw_version_time;
        this.last_comm = last_comm;
        this.address = address;
    }
}

interface IDevicesAPI {
    getDevices(pageNum: number, countPerPage: number): Promise<Device[]>;
    getDeviceCount(queryParams: string): Promise<number>;
    getDevicesFiltered(queryParams: string, pageNum: number, countPerPage: number): Promise<Device[]>;
    getAllDevicesFiltered(queryParams: string): Promise<Device[]>;
    addDevice(device: Device): Promise<void>;
    deleteDevice(id: string, deviceType: string): Promise<void>;
    editDevice(device: Device, oldDeviceType: string): Promise<void>;
    getFirmwares(): Promise<FirmwareView[]>;
    getDeviceTypes(): Promise<DeviceTypeView[]>;
    removeTagFromDevice(deviceId: string, deviceType: string, tag: string): Promise<void>;
    addTagToDevice(deviceId: string, deviceType: string, tag: string): Promise<void>;
    updateDevices(devices:Device[]): Promise<void>;
    deleteDevices(deviceIds:string[]): Promise<void>;
    uploadDevicesFile(file: File): Promise<void>;
    requestFirmware(devices: Device[]): Promise<void>;
}

export default IDevicesAPI;